import { useGetImprovementProposal } from "@/api/app/improvement-proposal/useGetImprovementProposal";
import LoadingScreen from "@/components/Loading";
import { Button } from "@/components/ui/button";
import { handlePrintPdf } from "@/lib/handlePrintPdf";
import ImprovementProposalResult from "@/src/_components/ImprovementProposalResult/ImprovementProposalResult";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

function ImprovementProposalDownloadPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id = "" } = useParams();
  const { data, isLoading } = useGetImprovementProposal(id);
  const [isPrinting, setPrinting] = useState(false);
  if (!data) {
    navigate("/app/assessment");
    return null;
  }
  if (isLoading) return <LoadingScreen />;

  return (
    <div className="h-full overflow-auto">
      <div className="flex  justify-between px-16 py-4 border-b border-cool-gray-200">
        <span className="text-2xl font-bold">{t("improvement-proposal")}</span>
        <Button
          isLoading={isPrinting}
          variant="outline"
          onClick={() => {
            setPrinting(true);
            handlePrintPdf(
              "improvement-proposal",
              "improvement-proposal",
              () => {
                setPrinting(false);
              },
            );
          }}
        >
          {t("download-proposal")}
        </Button>
      </div>
      <ImprovementProposalResult improvementProposal={data.data} />
    </div>
  );
}

export default ImprovementProposalDownloadPage;
